import monstera from "../assets/monstera.webp";
import lyrata from "../assets/lyrata.webp";
import pothos from "../assets/pothos.webp";
import succulent from "../assets/succulent.webp";
import olivier from "../assets/olivier.webp";
import basil from "../assets/basil.webp";
import mint from "../assets/mint.webp";
import calathea from "../assets/calathea.webp";
import cactus from "../assets/cactus.webp";

export const plantList = [
    {
        name: "monstera",
        category: "classique",
        id: "1ed",
        light: 2,
        water: 3,
        cover: monstera,
        price: 8
    },
    {
        name: "ficus lyrata",
        category: "classique",
        id: "2ab",
        light: 3,
        water: 1,
        cover: lyrata,
        price: 10
    },

    {
        name: "pothos argenté",
        category: "classique",
        id: "3sd",
        light: 1,
        water: 2,
        cover: pothos,
        price: 15
    },
    {
        name: "calathea",
        category: "classique",
        id: "4kk",
        light: 2,
        water: 3,
        cover: calathea,
        price: 17
    },
    {
        name: "olivier",
        category: "extérieur",
        id: "5pl",
        light: 3,
        water: 1,
        cover: olivier,
        price: 12
    },

    {
        name: "cactus",
        category: "plante grasse",
        id: "8fp",
        light: 2,
        water: 1,
        cover: cactus,
        price: 15
    },
    {
        name: "basilique",
        category: "extérieur",
        id: "7ie",
        light: 2,
        water: 3,
        cover: basil,
        price: 7
    },
    {
        name: "succulente",
        category: "plante grasse",
        id: "9vn",
        light: 2,
        water: 1,
        cover: succulent,
        price: 17
    },

    {
        name: "menthe",
        category: "extérieur",
        id: "6uo",
        light: 2,
        water: 2,
        cover: mint,
        price: 9
    },
];
